import { colors } from "components/Theme/WebTheme";
import {SECONDORY_COLOR,FONT_FAMILY} from "../../common/sharedFunctions"
const TableStyle = () => {
    return {
        editable: {
            backgroundColor: colors.Header_Text,
            fontSize: "0.8em",
            fontWeight: 600,
            fontFamily: FONT_FAMILY
          },
          pageSize: 10,
          pageSizeOptions: [10, 15, 20],
          headerStyle: {
            color: '#0f172a',
            position: "sticky",
            top: "0px",
            backgroundColor: '#f8fafc',
            textAlign: "center",
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            padding: '14px 10px',
            borderBottom: `1px solid ${SECONDORY_COLOR}`,
            border: 'none',
            fontFamily: FONT_FAMILY
          },
          cellStyle: {
            border: 'none',
            borderBottom: `1px solid ${SECONDORY_COLOR}`,
            textAlign: "center",
            padding: '14px 10px',
            fontSize: 13,
            color: '#334155',
            fontFamily: FONT_FAMILY,
          },
          actionsColumnIndex: -1,
        }
};

export default TableStyle;